import * as React from 'react'
import { Box, Drawer } from '@mantine/core'
import { NavbarContent } from '../NavbarContent'
import { Header } from './Header'

interface IProps {
  opened: boolean
  onClose: () => void
}

export const NavbarDrawer = ({ opened, onClose }: IProps) => {
  return (
    <Drawer
      padding={0}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size={300}
      styles={(theme) => ({
        content: {
          display: 'flex',
          flexDirection: 'column',
          boxShadow: theme.shadows.xs,
        },
      })}
    >
      <Header onNavLinkClick={onClose} />

      <Box className={'flex flex-1 overflow-hidden'}>
        <NavbarContent onNavLinkClick={onClose} />
      </Box>
    </Drawer>
  )
}
